export default "__VITE_ASSET__E69ZjrPV__"